export default "__VITE_ASSET__BdUq9Vye__"